import React from 'react';

/**
 * Renders the static media-kit / links page via an iframe so its
 * CSS/scripts stay fully isolated from the main site styling.
 *
 * Source file lives at: /app/frontend/public/links.html
 * (served directly by React's static asset pipeline).
 */
const LinksPage = () => {
  return (
    <div
      className="dark-page links-page-wrapper"
      style={{
        minHeight: '100vh',
        background: '#0a0512',
      }}
      data-testid="links-page"
    >
      <iframe
        src="/links.html"
        title="The Collins Academy — Links & Media Kit"
        data-testid="links-iframe"
        style={{
          width: '100%',
          minHeight: 'calc(100vh - 100px)',
          height: '100%',
          border: 'none',
          display: 'block',
          background: 'transparent',
        }}
        loading="eager"
      />
    </div>
  );
};

export default LinksPage;
